import "../../App.css";
import barra_1 from "../../img/svg/barra_1.png";
import barra_2 from "../../img/svg/barra_2.svg";
import barra_txt from "../../img/svg/barra_txt.svg";
import icn_1 from "../../img/svg/icn_1.svg";
import icn_2 from "../../img/svg/icn_2.svg";
import icn_3 from "../../img/svg/icn_3.svg";
import check_mark from "../../img/check_mark.png";
import phone from "../../img/svg/phone-flip-solid.svg";
import twitter from "../../img/svg/twitter.svg";
import facebook from "../../img/svg/facebook.svg";
import instagram from "../../img/svg/instagram.svg";
import arrow from "../../img/svg/arrow-repeat.svg";
import axios from "axios";
import { useEffect } from "react";
import Loader from "../loader/loader";
import APIS from "../../services/apis";
const caracteristicasImg = [check_mark, check_mark, check_mark];

function Step6({
  setPage,
  certificado,
  valor_matricula_anual,
  valor_arancel_anual,
  valor_beca_matricula_unab,
  valor_beca_arancel_unab,
  valor_matricula_anual_unab,
  valor_anual_con_becas,
  valor_mensual_con_becas,
  valor_sede,
  valor_nombre_carrera,
  url_pdf,
  caracteristica_1,
  caracteristica_2,
  caracteristica_3,
  setNuevaSimulacion,
  loadingFinal,
  setLoadingFinal,
  permitir_envio,
  jwt
}) {
  const certificadoGet = () => {
    //vespertino/certificado/enviar/{idCertificado}
    //

    APIS.sendCertificado({}, certificado, jwt)
      .then((response) => {
        alert("Se envió el certificado Correctamente");
      })
      .catch(function (error) {
        console.error(error);
        alert("No se pudo enviar el certificado, intente nuevamente.");
      });
  };

  const url_certificado = process.env.REACT_APP_URL_CERTIFICADO;

  return (
    <section>
      {loadingFinal ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          <div class="in">
            <header class="marquee bg--color6">
              <div class="in">
                <div class="maxwidth">
                  <div class="logo"></div>
                  <div class="ttl">
                    <span class="num fonty"></span>
                    <h2>Resultados</h2>
                  </div>
                  <div class="air gone"></div>
                </div>
              </div>
            </header>
            <main id="content-result" className="final_section">
              <div class="bg--color6 padded--left padded--right">
                <div class="maxwidth2">
                  <div class="ttl big titular text--center color--color4">
                    <p>
                      Estos son los{" "}
                      <strong className="bold_letter">
                        Valores y becas para{" "}
                        <span class="user--carrera">
                          {valor_nombre_carrera}
                        </span>
                      </strong>
                    </p>
                  </div>
                  <div class="text--center">
                    <h3 class="special ">
                      Sede <span class="user--sede">{valor_sede}</span>
                    </h3>
                  </div>
                </div>
                <div id="tablas" class="maxwidth space--up padded--leftt">
                  <div class="cols cols2 stretched">
                    <div class="col col1">
                      <div class="bg--color1 padded">
                        <div class="table blue_table">
                          <div class="text--center">
                            <h3 class="special color--color2">Valor regular</h3>
                          </div>
                          <table class="medium--2 ">
                            <tbody>
                              <tr>
                                <td>Valor matrícula</td>
                                <td>
                                  <span class="tachado">
                                    $
                                    {valor_matricula_anual.toLocaleString("es")}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td>Valor anual</td>
                                <td>
                                  <span class="tachado">
                                    ${valor_arancel_anual.toLocaleString("es")}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="table">
                          <div class="text--center">
                            <h3 class="special color--color3">Descuentos</h3>
                          </div>
                          <table class="medium--2">
                            <tbody>
                              <tr class="color--color3">
                                <td>
                                  <i class="fas fa-check"></i>
                                  Matrícula gratis
                                </td>
                                <td>
                                  -$
                                  {valor_beca_matricula_unab.toLocaleString(
                                    "es"
                                  )}
                                </td>
                              </tr>
                              {valor_beca_arancel_unab > 0 ? (
                                <>
                                  <tr class="color--color3">
                                    <td className="tick_wrapper">
                                      Beca arancel anual UNAB
                                    </td>
                                    <td>
                                      -$
                                      {valor_beca_arancel_unab.toLocaleString(
                                        "es"
                                      )}
                                    </td>
                                  </tr>
                                </>
                              ) : null}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="col col1">
                      <div class="bg--color4 color--color1 padded">
                        <div class="table ">
                          <div class="ttl text--center">
                            <div>
                              <h3 class="special color--color1">
                                Total a pagar
                              </h3>
                            </div>
                          </div>
                          <table class="medium--2">
                            <tbody className="color--1-text">
                              <tr>
                                <td>
                                  Matrícula anual
                                  <div class="small">Gratis el primer año</div>
                                </td>
                                <td>$0</td>
                              </tr>
                              <tr>
                                <td>Valor carrera anual con Beca</td>
                                <td>
                                  ${valor_anual_con_becas.toLocaleString("es")}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  Valor carrera mensual con Beca
                                  <div class="small">
                                    Calculado en 10 cuotas
                                  </div>
                                </td>
                                <td>
                                  <span>
                                    $
                                    {valor_mensual_con_becas.toLocaleString(
                                      "es"
                                    )}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <i class="clear"></i>
                  </div>
                </div>
                <div class="maxwidth2 titular text--center padded">
                  <div class="cols cols3">
                    <div class="col col1">
                      <div class="icn color--color3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="56"
                          height="56"
                          fill="currentColor"
                          class="bi bi-download"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                        </svg>
                      </div>
                      <div class="button medium--2">
                        <a
                          class="bg--color4 color--1-text"
                          target="_blank"
                          rel="noreferrer"
                          href={url_certificado}
                        >
                          Condiciones de la beca
                        </a>
                      </div>
                    </div>
                    {permitir_envio && (
                      <>
                        <div class="col col1">
                          <div class="icn color--color3">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="56"
                              height="56"
                              fill="currentColor"
                              class="bi bi-envelope-open"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8.47 1.318a1 1 0 0 0-.94 0l-6 3.2A1 1 0 0 0 1 5.4v.817l5.75 3.45L8 8.917l1.25.75L15 6.217V5.4a1 1 0 0 0-.53-.882l-6-3.2ZM15 7.383l-4.778 2.867L15 13.117V7.383Zm-.035 6.88L8 10.082l-6.965 4.18A1 1 0 0 0 2 15h12a1 1 0 0 0 .965-.738ZM1 13.116l4.778-2.867L1 7.383v5.734ZM7.059.435a2 2 0 0 1 1.882 0l6 3.2A2 2 0 0 1 16 5.4V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.4a2 2 0 0 1 1.059-1.765l6-3.2Z" />
                            </svg>
                          </div>
                          <div class="button medium--2">
                            <a
                              class="bg--color4 color--1-text"
                              onClick={() => certificadoGet()}
                            >
                              Enviar a mi correo
                            </a>
                          </div>
                        </div>
                      </>
                    )}
                    <div class="col col1">
                      <div class="icn color--color3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="56"
                          height="56"
                          fill="currentColor"
                          class="bi bi-mortarboard"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917l-7.5-3.5ZM8 8.46 1.758 5.965 8 3.052l6.242 2.913L8 8.46Z" />
                          <path d="M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466 4.176 9.032Zm-.068 1.873.22-.748 3.496 1.311a.5.5 0 0 0 .352 0l3.496-1.311.22.748L8 12.46l-3.892-1.556Z" />
                        </svg>
                      </div>
                      <div class="button medium--2">
                        <button class="postula bg--color5 color--1-text">
                          <a
                            href="https://postulacionsua.unab.cl/pregradovespertino.aspx"
                            target="_blank" rel="noreferrer"
                          >
                            <strong className="bold_letter">
                              {" "}
                              Postular &raquo;
                            </strong>
                          </a>
                        </button>
                      </div>
                    </div>
                    <span class="clear"></span>
                  </div>
                </div>
              </div>
              <div class="padded has--bg bg--color1 color--color2">
                <div class="maxwidth2 popup--style">
                  <h3 class="titular big text--center color--color4">
                    <span style={{ fontWeight: 300 }}>¿Por qué estudiar</span>{" "}
                    <strong>
                      <span class="user--carrera">{valor_nombre_carrera}</span>{" "}
                      en la UNAB
                    </strong>
                    <span style={{ fontWeight: 300 }}>?</span>
                  </h3>
                  <ul
                    class="maxwidth2 color--color7"
                    style={{ marginTop: "2em" }}
                  >
                    <li>
                      <span class="icn">
                        <img alt="" src={caracteristicasImg[0]} />
                      </span>
                      <div>{caracteristica_1}</div>
                    </li>
                    <li>
                      <span class="icn">
                        <img alt="" src={caracteristicasImg[1]} />
                      </span>
                      <div>{caracteristica_2}</div>
                    </li>
                    <li>
                      <span class="icn">
                        <img alt="" src={caracteristicasImg[2]} />
                      </span>
                      <div>{caracteristica_3}</div>
                    </li>
                  </ul>
                </div>
                <div class="maxwidth2 titular text--center padded">
                  <div class="cols cols2">
                    <div class="col col1">
                      <div class="icn color--color3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="56"
                          height="56"
                          fill="currentColor"
                          class="bi bi-download"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                        </svg>
                      </div>
                      <div class="button medium--2">
                        <a
                          class="bg--color4 color--1-text"
                          href={url_pdf}
                          target="_blank" rel="noreferrer"
                        >
                          Descargar malla
                        </a>
                      </div>
                    </div>
                    <span class="clear"></span>
                  </div>
                </div>
              </div>
              <div class="padded has--bg bg--color3 color--color1 text--center">
                <div
                  className="button medium--2"
                  onClick={() => {
                    setNuevaSimulacion(true);
                    setPage(3);
                    setLoadingFinal(true);
                  }}
                >
                  <a class="border retry">
                    <div className="bold_letter color--color1 repeat">
                      Volver a simular
                      <img alt="" className="repeat_icon" src={arrow} />
                    </div>
                  </a>
                </div>
              </div>
              <div class="final_social padded bg--color6">
                <div class="maxwidth text--center">
                  <div class="cols cols2">
                    <div class="col col1">
                      <h4 class="color--color7">¿Tienes dudas?</h4>
                      <div class="buttons">
                        <a class="button" href="https://api.whatsapp.com/send?phone=56946171786">
                          <div className="blue_circle">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              class="bi bi-whatsapp blue_circle_whatsapp"
                              viewBox="0 0 16 16"
                            >
                              <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                            </svg>
                          </div>
                          <div class="color--color4 icon_text">WhatsApp</div>
                        </a>
                        <a class="button" href="https://api.whatsapp.com/send?phone=56946171786">
                          <div className="blue_circle">
                            <img
                              className="blue_circle_phone"
                              src={phone}
                              alt=""
                            />
                          </div>
                          <div class="color--color4 icon_text">
                            600 228 6262
                          </div>
                        </a>
                      </div>
                      <p class="small color--color4">
                        Horario de atención Lunes a Viernes de 09:00 a 20:00 hrs
                      </p>
                    </div>
                    <div class="col col1">
                      <h4 class="color--color7">Síguenos en</h4>
                      <div class="buttons">
                        <a
                          class="button"
                          href="https://twitter.com/admision_unab"
                          target="_blank" rel="noreferrer"
                        >
                          <div className="blue_circle">
                            <img
                              className="blue_circle_social"
                              src={twitter}
                              alt=""
                            />
                          </div>
                        </a>
                        <a
                          class="button"
                          href="https://www.instagram.com/admision_unab/?hl=es-la"
                          target="_blank" rel="noreferrer"
                        >
                          <div className="blue_circle">
                            <img
                              className="blue_circle_social social_insta"
                              src={instagram}
                              alt=""
                            />
                          </div>
                        </a>
                        <a
                          class="button"
                          href="https://www.facebook.com/AdmisionUNAB"
                          target="_blank" rel="noreferrer"
                        >
                          <div className="blue_circle">
                            <img
                              className="blue_circle_social"
                              src={facebook}
                              alt=""
                            />
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
            <footer class="marquee has--barra">
              <div class="barra">
                <div class="in maxwidth">
                  <div class="left">
                    <img className="barraN" alt="" src={barra_1} />
                    <img className="barraN" alt="" src={barra_2} />
                  </div>
                  <div class="right">
                    <img alt="" className="barraText" src={barra_txt} />
                  </div>
                  <span class="clear"></span>
                </div>
              </div>
            </footer>
          </div>
        </>
      )}
    </section>
  );
}

export default Step6;
